Date.prototype.format = function (format) {
    var o = {
        'M+': this.getMonth() + 1, // month
        'd+': this.getDate(), // day
        'h+': this.getHours(), // hour
        'm+': this.getMinutes(), // minute
        's+': this.getSeconds(), // second
        'q+': Math.floor((this.getMonth() + 3) / 3), // quarter
        'S': this.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
    }
    return format
}
const tool = {
    // 年的截取
    year(dates) {
        if (dates) {
            var date = new Date(dates)
            return date.format('yyyy-MM-dd')
        } else {
            return "-"
        }
    },
    yDate(dates) {
        if (dates) {
            var date = new Date(dates)
            return date.format('yyyy-MM-dd hh:mm')
        } else {
            return "-"
        }
    },
    sDate(dates) {
        if (dates) {
            var date = new Date(dates)
            return date.format('yyyyMMddhhmmss')
        } else {
            return "-"
        }
    },
    dateForm(dates, format){
        if (dates) {
            var date = new Date(dates)
            return date.format(format)
        } else {
            return "-"
        }
    },
    date(dates) {
        if (dates) {
            var date = new Date(dates)
            return date.format('yyyy-MM-dd hh:mm:ss')
        } else {
            return "-"
        }
    },
    //计算两个时间格式的字符串相差的周数、月数、年数
    //‘2019-3-12， 2019-4-29’ ==》 {year:0,month:1,week:xx}
    
}

export default tool
